export default {
  LETTER_SOUNDS: 'measure.letter_sounds',
  MIND_THE_GAP: 'measure.mind_the_gap',
  REAL_WORD_READING: 'measure.real_word_reading',
  SYLLABLE_DECODING: 'measure.syllable_decoding',
  BLENDING: 'measure.blending',
  LETTER_SOUND_CORRESPONDENCES: 'measure.letter_sound_correspondences',
  SEGMENTING: 'measure.segmenting',
};
